import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FastracDxGridWrapperComponent, FastracScreenBaseComponent } from '@bds/fastrac';
import { FastracColsService } from '@bds/services';
import { CommunicationService, nameof } from '@bds/core';
import { CarIdTransformService } from '@bds/helpers';
import { bdsGridModeType } from '@bds/components';
import { RailtracReportsService } from '../../railtrac-reports.service';
import { PageService } from '@bds/core';
import { ReportConstants } from '../../models/report-parameters.model';
import DataSource from 'devextreme/data/data_source';

@Component({
    selector: 'lib-rt-shipment-history-detail-report',
    templateUrl: './rt-shipment-history-detail-report.component.html',
    styleUrls: ['./rt-shipment-history-detail-report.component.css'],
})
export class RtShipmentHistoryDetailReportComponent
    extends FastracScreenBaseComponent
    implements OnInit, OnDestroy
{
    public gridId = 123;
    public gridMode: bdsGridModeType = 'single';
    public gridSource: any;
    public selectedRowKeys: Array<number> = [];
    public controlNames: string[] = ['Shipment Begin Date', 'Shipment End Date'];

    public displayReport: boolean = false;

    @ViewChild(FastracDxGridWrapperComponent) set wrapper(w: FastracDxGridWrapperComponent) {
        Promise.resolve().then(() => {
            const grid = w?.grid?.instance;
            if (!grid) {
                return;
            }
            grid.option('onRowDblClick', (e: any) => this.onRowDblClick(e));
        });
    }

    constructor(
        public router: Router,
        public route: ActivatedRoute,
        public gridColumnService: FastracColsService,
        public communicationService: CommunicationService,
        public carIdTransformService: CarIdTransformService,
        public reportService: RailtracReportsService,
        public pageService: PageService,
    ) {
        super(router, route, gridColumnService, communicationService, carIdTransformService);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.pageService.setHeader('Shipment History Detail Report');

        this.customizeColumns = (columns: any[]) => {
            const datePipe = new DatePipe('en-US');
            const shipCol = columns.find((c) => c.dataField === 'ship_date_time');
            if (shipCol) {
                shipCol.dataType = 'datetime';
                shipCol.calculateDisplayValue = (rowData: any) => {
                    const value = rowData['ship_date_time'];
                    return value ? datePipe.transform(value, 'MM/dd/yyyy HH:mm', 'UTC') : '';
                };
            }
        };
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    onGetReportClick(event: any) {
        this.displayReport = true;
        this.gridSource = new DataSource(
            this.reportService.CreateAspNetDatastore(
                ReportConstants.ReportDataApiCall,
                this.gridId.toString(),
                event.startDate,
                event.endDate,
            ),
        );
    }

    onCancelClick() {
        this.displayReport = false;
    }

    onRowDblClick(e: any) {
        const ormId = e?.data?.orm_id;
        if (ormId == null) {
            return;
        }
        window.open(`/trips/detail/${ormId}#tripdetailsanchor`, '_blank');
    }
}
